(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!form.matches('[data-shop-filters]')) return;
  const low = form.querySelector('[name="filter.v.price.gte"]');
  const high = form.querySelector('[name="filter.v.price.lte"]');
  if (low.value !== '' && high.value !== '' && Number(low.value) > Number(high.value)) {
    const previous = low.value;
    low.value = high.value;
    high.value = previous;
  }
  [low, high].forEach(function(input) { if (input.value === '') input.disabled = true; });
});

  } catch(e) { console.error(e); }
})();
})();
